<template>
    <div class="select">
        <div class="select__wrapper">
            <multiselect v-model="selected" :options="options"
                         :multiple="true"
                         :searchable="false"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="false"
                         selected-label="Выбран"
                         select-label=""
                         deselect-label=""
                         delete-label=""
                         @close="selectClose"
                         placeholder="Корпус" label="title" track-by="name">
                <template slot="selection"
                          slot-scope="{ values, search, isOpen }"
                >
                <span class="multiselect__single"
                   v-if="values.length &amp;&amp; !isOpen">Корпусов выбрано: {{ values.length }}
                </span>
                </template>
            </multiselect>

        </div>
    </div>

</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Multiselect from 'vue-multiselect';


export default {
    components: {Multiselect},
    props     : ['building'],
    data() {
        return {
            selected: [],
            options : [],
            isInit  : false
        };
    },
    watch: {
        // устанавливаем список доступных для выбора опций для мультиселекта
        building() {
            if (this.building) {
                this.options = [];

                for (const item in this.building) {
                    if ({}.hasOwnProperty.call(this.building, item)) {
                        const rv = {};

                        // eslint-disable-next-line no-undefined
                        if (this.building[item] !== undefined) {
                            rv[item] = this.building[item];
                            this.options.push(rv[item]);
                        }
                    }
                }
            }
        },
        // утанавливаем выбранные здания для vue-мультиселекта
        selectedObjects() {
            this.selected = [];
            this.selected = this.selectedObjects;
        }
    },
    methods: {
        ...mapActions(['closeSelected']),

        selectClose() {
            // при закрытии селекта обновляем данные в сторе
            const arr = [];

            for (const item in this.selected) {
                if ({}.hasOwnProperty.call(this.selected, item)) {
                    arr.push(this.selected[item].id);
                }
            }
            this.closeSelected(arr);
            this.$emit('selectric-select');
        }
    },
    computed: {
        ...mapGetters({
            selectedBuildings: 'GET_SELECTED_BUILDINGS',
            selectedObjects  : 'GET_SELECTED_OBJECTS'
        })
    }
};
</script>


